module.exports = __webpack_public_path__ + "img/dcfl09.f4bb072e.png";